import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import { AuthGuard } from './components/AuthGuard'
import { Dashboard } from './pages/Dashboard'
import { ConfigureApp } from './pages/ConfigureApp'
import { AppHistory } from './pages/AppHistory'
import { AppDetail } from './pages/AppDetail'
import { StoreSettings } from './pages/StoreSettings'

function App() {
  return (
    <AuthGuard>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/configure" element={<ConfigureApp />} />
          <Route path="/history" element={<AppHistory />} />
          <Route path="/apps/:appId" element={<AppDetail />} />
          <Route path="/apps/:appId/edit" element={<ConfigureApp />} />
          <Route path="/settings/stores" element={<StoreSettings />} />
        </Routes>
      </Layout>
    </AuthGuard>
  )
}

export default App 